import { z } from 'zod';
import { requiredUuidString } from '../zod-helpers/index.js';
import { MAX_PART_BRAND_IDS } from './constraints.js';
/** No minimum: an empty list clears only the brands the caller can see. */
export const setPartBrandsInputSchema = z.object({
    partId: requiredUuidString('Part is required.', 'Invalid part selection.'),
    brandIds: z
        .array(requiredUuidString('Brand is required.', 'Invalid brand selection.'))
        .max(MAX_PART_BRAND_IDS, `Select at most ${MAX_PART_BRAND_IDS} brands.`),
});
//# sourceMappingURL=set-brands-input.js.map